// Utilities for validation and formatting

export const formatCPF = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return value;
};

export const validateCPF = (cpf) => {
  const numbers = cpf.replace(/\D/g, '');
  
  if (numbers.length !== 11) return false;
  
  // Check if all digits are the same
  if (/^(\d)\1{10}$/.test(numbers)) return false;
  
  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(numbers.charAt(i)) * (10 - i);
  }
  let digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(numbers.charAt(9))) return false;
  
  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(numbers.charAt(i)) * (11 - i);
  }
  digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(numbers.charAt(10))) return false;
  
  return true;
};

export const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length <= 11) {
    if (numbers.length <= 10) {
      // Format: (11) 9999-9999
      return numbers
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      // Format: (11) 99999-9999
      return numbers
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2');
    }
  }
  return value;
};

export const extractPatientDataFromAnswers = (questions, answers) => {
  const data = {
    full_name: '',
    email: '',
    phone: '',
    birth_date: '',
    cpf: '',
    address: ''
  };

  if (!questions || !answers) {
    console.log('⚠️ extractPatientDataFromAnswers: questions ou answers ausentes', { questions, answers });
    return data;
  }

  console.log('🔍 Iniciando extração de dados. Questions:', questions.length, 'Answers:', answers.length);

  questions.forEach((question, qIndex) => {
    const answer = answers.find(a => a.question_id === question.id);
    
    if (!answer || !answer.answer) {
      console.log(`⚠️ Pergunta ${qIndex + 1} (${question.id}): sem resposta encontrada`);
      return;
    }

    const questionText = (question.question_text || question.label || '').toLowerCase();
    const answerValue = answer.answer;
    
    console.log(`✓ Pergunta ${qIndex + 1}: "${questionText}" = "${answerValue}"`);

    // Full name
    if (questionText.includes('nome completo') || questionText.includes('nome do paciente')) {
      data.full_name = answerValue;
      console.log('  → Nome completo extraído:', answerValue);
    }
    
    // Email
    if (questionText.includes('email') || questionText.includes('e-mail') || questionText.includes('correio eletronico')) {
      data.email = answerValue;
      console.log('  → Email extraído:', answerValue);
    }
    
    // Phone
    if (questionText.includes('telefone') || questionText.includes('celular') || questionText.includes('tel') || questionText.includes('contato')) {
      data.phone = answerValue;
      console.log('  → Telefone extraído:', answerValue);
    }
    
    // Birth date
    if (questionText.includes('nascimento') || questionText.includes('data de nasc') || questionText.includes('aniversario') || questionText.includes('data nasc')) {
      data.birth_date = answerValue;
      console.log('  → Data de nascimento extraída:', answerValue);
    }
    
    // CPF
    if (questionText.includes('cpf') || questionText.includes('c.p.f')) {
      data.cpf = answerValue;
      console.log('  → CPF extraído:', answerValue);
    }
    
    // Address
    if (questionText.includes('endereco') || questionText.includes('endereço') || questionText.includes('rua') || questionText.includes('logradouro')) {
      data.address = answerValue;
      console.log('  → Endereço extraído:', answerValue);
    }
  });

  console.log('🎯 Resultado final da extração:', data);
  return data;
};
